/**
 * Auth Interceptor
 * Attaches Access Token to outgoing requests
 * 
 * Security Note:
 * - Access Token is retrieved from memory (Pinia Store)
 * - Never reads from localStorage
 */

import type { Interceptor } from '@connectrpc/connect';
import { useAuthStore } from '@/stores/auth';

export const authInterceptor: Interceptor = (next) => async (req) => {
  const authStore = useAuthStore();
  const token = authStore.getAccessToken();
  
  if (token) {
    req.header.set('Authorization', `Bearer ${token}`);
  }
  
  return next(req);
};

